/**
 * Product terminology layer.
 *
 * The progression unit is branded as BEE in every user-facing surface.
 * Internal code (variables, types, constants such as DAILY_BASE_XP) may still
 * say "xp"; only rendered copy is affected. Life Score is a different concept
 * and is never renamed.
 *
 * Applied once, centrally, inside the i18n lookup — screens never rename
 * the unit themselves.
 */
export const PROGRESS_UNIT = 'Bee'

export function applyTerms(text: string): string {
  return text.replace(/\bXP\b/g, PROGRESS_UNIT)
}
